export default __webpack_public_path__ + "static/media/expandMoreGray24px.86c18051.svg";